import React from 'react'
import { Link } from 'react-router-dom';

const SNKB_History = () => {
  return (
    <div>
        <>
            {/* Page Title Section */}
            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/assets/img/bg-img.png)' }}></div>
                <div className="line-box">
                    <div className="line-1"></div>
                    <div className="line-2"></div>
                </div>
                <div className="auto-container">
                    <div className="content-box">
                        <h1>History</h1>
                        <ul className="bread-crumb clearfix">
                            <li><Link  to="/">Home</Link></li>
                            <li>History</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/* Page Title End */}

            {/* History Section */}
            <section className="history-section">
                <div className="auto-container">
                    <div className="inner-box">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                <div className="image-box">
                                    <figure className="image"><img src="/assets/img/his-5.png" alt="Founder" /></figure>
                                    <div className="link-box"><Link ><i className="flaticon-diagonal-arrow"></i></Link></div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                <div className="content-box">
                                    <h2>Founder of SNKB Japan</h2>
                                    <div className="text">
                                        <h3>Mr.N.K.SHAH</h3>
                                        <p>SNKB ROLLING BEARINGS is an exclusive set-up designed to meet the needs of the emerging Asian Economic Powerhouse. The company offers access to the entire Range of world-class products & Services manufactured by SNKB worldwide.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-box">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                <div className="content-box">
                                    <div className="text">
                                        <p>Through an offering of best-in-class quality SNKB bearing and accessories, SNKB India brings to Indian Original Equipment Manufacturers and end users an experience of seamless operations through the integrated quality systems built-in these products, while meeting the unique requirements of the individual organizations and applications that it serves.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                <div className="image-box">
                                    <figure className="image"><img src="/assets/img/his-2.png" alt="History Image 2" /></figure>
                                    <div className="link-box"><Link ><i className="flaticon-diagonal-arrow"></i></Link></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-box">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                <div className="image-box">
                                    <figure className="image"><img src="/assets/img/his-3.png" alt="History Image 3" /></figure>
                                    <div className="link-box"><Link ><i className="flaticon-diagonal-arrow"></i></Link></div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                <div className="content-box">
                                    <div className="text">
                                        <p>SNKB India stands endorsed by key players across various sectors, including Railways, Power, Automobiles, Engineering, and beyond. This widespread approval underscores our reputation for excellence and reliability in delivering top-notch bearings and related solutions to meet the diverse needs of industries nationwide.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="inner-box">
                        <div className="row clearfix">
                            <div className="col-lg-6 col-md-6 col-sm-12 content-column">
                                <div className="content-box">
                                    <div className="text">
                                        <p>SNKB JAPAN proudly holds the ISO 9001:2015 certification, affirming our commitment to exceptional quality standards. Based in Mumbai, our operations focus on distributing high-quality bearings. Our certification, with the unique identifier 20ZAZG03408Q, underscores our dedication to quality management. Regular surveillance audits conducted on 03/01/2021 and 03/01/2022 validate our adherence to ISO standards. Issued on 04/01/2020, our certification remains valid until 03/01/2023, reflecting our enduring pursuit of excellence and customer satisfaction.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 image-column">
                                <div className="image-box">
                                    <figure className="image"><img src="/assets/img/his-4.png" style={{ height: '450px' }} alt="History Image 4" /></figure>
                                    <div className="link-box"><Link ><i className="flaticon-diagonal-arrow"></i></Link></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* History Section End */}
        </>
    </div>
  )
}

export default SNKB_History
